<h2
    mat-dialog-title
    class="tt-secondary-background"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragBoundary=".cdk-overlay-container"
    cdkDragHandle
    style="color: white"
    ttTranslateWord="email_archive_heading"
></h2>
<mat-dialog-content class="email-archive-dialog-content">
    <tt-email-archive-form
        [showCreateVoucher]="data.get.show_buttons_accounting === '1'"
        [archiveHeading]="data.get.heading_email_archiving || ''"
        [email]="data.email"
        (emailArchived)="onEmailArchived($event)"
    ></tt-email-archive-form>
</mat-dialog-content>
